export const suitServices = [
  {
    id: 1,
    title: 'Traje a Medida Clásico',
    description: 'Confección artesanal de trajes de corte clásico con tejidos de alta calidad. Perfecto para bodas, galas y eventos formales donde la elegancia atemporal es esencial.',
    icon: 'ri-shirt-line',
  },
  {
    id: 2,
    title: 'Smoking & Black Tie',
    description: 'Diseño y confección de smoking de alta costura para eventos de etiqueta. Solapas de pico, raso y detalles de seda natural para un look impecable.',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 3,
    title: 'Chaqués & Morning Coat',
    description: 'Trajes de chaqué tradicionales para ceremonias de día y bodas matinales. Corte estructurado con tejidos ingleses y detalles bordados a mano.',
    icon: 'ri-scissors-cut-line',
  },
  {
    id: 4,
    title: 'Pruebas de Ajuste',
    description: 'Entre 3 y 4 sesiones de prueba a lo largo del proceso. Ajustamos la estructura, la caída de la chaqueta y cada detalle para un ajuste perfecto.',
    icon: 'ri-user-heart-line',
  },
];

export const suitTestimonials = [
  {
    id: 1,
    name: 'Carlos Martínez',
    role: 'Cliente — Boda Abril 2025',
    text: 'Anthony entendió exactamente lo que buscaba: un traje clásico con un toque moderno. La calidad de la lana y los acabados son impecables. Me sentí como un rey en mi boda.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Javier Ruiz',
    role: 'Cliente — Gala Fundación Junio 2025',
    text: 'Necesitaba un smoking para una gala benéfica y el resultado superó todas mis expectativas. La solapa de pico con raso negro es espectacular. Totalmente recomendable.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Andrés Belmonte',
    role: 'Cliente — Boda Octubre 2024',
    text: 'Me hicieron un chaqué para una boda matinal y fue el centro de atención. El corte estructurado y los botones forrados a mano muestran el nivel de detalle del atelier.',
    rating: 5,
  },
];

export const suitFaqs = [
  {
    question: '¿Cuánto tiempo tarda la confección de un traje a medida?',
    answer: 'Recomendamos reservar con al menos 4-6 meses de antelación para trajes de alta costura. Para diseños con bordados complejos o tejidos especiales, 6-8 meses es ideal. Así garantizamos tiempo suficiente para el proceso creativo y las pruebas de ajuste.',
  },
  {
    question: '¿Cuál es el precio de un traje a medida de alta costura?',
    answer: 'Nuestros trajes a medida parten desde 3.800€. El precio final depende del diseño, los tejidos seleccionados (lana italiana, seda natural, cachemir), el grado de detalle y los acabados. Durante la primera consulta te presentamos un presupuesto detallado y transparente.',
  },
  {
    question: '¿Puedo traer referencias o ideas?',
    answer: 'Por supuesto. Las referencias visuales son una excelente forma de comunicar tu visión. Anthony analizará cada detalle para crear algo único que combine tu inspiración con su expertise de diseñador de alta costura.',
  },
  {
    question: '¿Qué tejidos utilizan para los trajes?',
    answer: 'Trabajamos con las mejores lanas italianas y británicas (Vitale Barberis Canonico, Holland & Sherry), sedas naturales para forros y raso, y cachemire para chaquetas especiales. Cada tejido es seleccionado personalmente según tu estilo y el uso del traje.',
  },
  {
    question: '¿Trabajáis con clientes internacionales?',
    answer: 'Sí, trabajamos con clientes de toda España, Europa y América Latina. Coordinamos las sesiones de prueba en Barcelona durante visitas planificadas y ofrecemos consultas online para el seguimiento del diseño.',
  },
  {
    question: '¿Incluye alguna garantía de ajuste?',
    answer: 'Incluimos una sesión de ajuste final aproximadamente 2 semanas antes del evento. También ofrecemos servicio de arreglos urgentes si necesitas alguna adaptación menor. La primera alteración está incluida en el precio.',
  },
];

export const suitProcess = [
  {
    step: 1,
    title: 'Consulta Inicial',
    description: 'Conversamos sobre tu estilo, el tipo de evento, tu silueta y presupuesto. Analizamos referencias y bocetamos las primeras ideas. Duración: 60 minutos.',
  },
  {
    step: 2,
    title: 'Diseño & Tejidos',
    description: 'Anthony presenta el boceto definitivo y seleccionamos juntos los tejidos. Definimos solapas, botones, forro y cada detalle del traje.',
  },
  {
    step: 3,
    title: 'Confección Artesanal',
    description: 'Cada pieza es confeccionada a mano en nuestro atelier. Las costuras, ojales y detalles se realizan artesanalmente por nuestros sastres expertos.',
  },
  {
    step: 4,
    title: 'Pruebas de Ajuste',
    description: 'Entre 3 y 4 sesiones donde ajustamos la estructura de la chaqueta, la caída del pantalón y cada detalle para un ajuste impecable.',
  },
  {
    step: 5,
    title: 'Entrega Final',
    description: 'Una última prueba dos semanas antes del evento. Te entregamos el traje enfundado en nuestro packaging de lujo, listo para brillar.',
  },
];